<template>
    <div>
        <q-table
            ref="table"
            :pagination.sync="server_pagination"
            :data="materials"
            :columns="columns"
            @request="requestMaterials"
            :loading="loading"
            row-key="id"
            :no-data-label="$t('no_data_avaliable')"
            :no-results-label="$t('no_results_found')"
            :loading-label="$t('loading_data')"
            :rows-per-page-label="$t('items_per_page')"
            :rows-per-page-options="[0]"
            hide-bottom
            class="shadow-0"
            v-if="$q.platform.is.desktop"
            >

            <q-tr slot="header" slot-scope="props" :props="props">
                <q-th v-for="col in props.cols" :key="col.name" :props="props">
                {{ $t(col.label) }}
                </q-th>
            </q-tr>

            <template slot="body" slot-scope="props">
                <q-tr :props="props" class="cursor-pointer" @click.native="showModal(props.row)">
                    <q-td key="title" :props="props">
                        {{ props.row.title }}
                    </q-td>

                    <q-td key="extension" :props="props" class="uppercase">
                        <q-icon :name="$extensionIcon(props.row.extension)" class="q-mr-sm" /> {{ props.row.extension }}
                    </q-td>

                    <q-td key="size" :props="props">
                        {{ props.row.size }}
                    </q-td>

                    <q-td key="hits" :props="props" auto-width>
                        {{ props.row.hits }}
                    </q-td>
                </q-tr>
            </template>
        </q-table>

        <q-card class="bg-grey-1 q-mb-lg cursor-pointer" v-for="(mat, index) in materials" :key="index" v-if="$q.platform.is.mobile">
            <q-card-main class="relative-position">
                <div class="line-card bg-primary absolute-top"></div>

                <div class="row gutter-sm">
                    <div class="col-12">
                        <p class="q-subheading">{{ mat.title }}</p>
                    </div>
                </div>
            </q-card-main>

            <q-card-separator />

            <q-card-actions class="justify-center">
                <q-btn flat :label="mat.size" icon="fal fa-hdd" />
                <q-btn flat :label="mat.hits" icon="fal fa-download" />
                <q-btn flat :label="mat.extension" :icon="$extensionIcon(mat.extension)" />
            </q-card-actions>

            <q-card-separator />

            <q-card-actions class="justify-center">
                <q-btn class="full-width q-my-sm" :label="$t('download')" icon="fal fa-download" color="primary" @click="showModal(mat)" />
            </q-card-actions>
        </q-card>

        <q-card class="bg-grey-1 cursor-pointer" v-if="materials.length == 0">
            <q-card-main class="relative-position">
                <div class="line-card bg-primary absolute-top"></div>

                <div class="row gutter-sm">
                    <div class="col-12">
                        <p class="q-subheading">{{ $t('no_items_found') }}</p>
                    </div>
                </div>
            </q-card-main>
        </q-card>

        <material-modal :material="material" :show="show_modal" @hideModal="hideModal()" />
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MaterialModal from 'components/presential_viewer/SupportMaterialModal'

export default {
    data() {
        return {
            server_pagination: {
                page: 1,
                rowsNumber: 10,
                rowsPerPage: 0,
                descending: false,
                sortBy: 'order'
            },
            columns: [
                {
                    name: 'title',
                    required: true,
                    label: 'title',
                    align: 'left',
                    field: 'title',
                    sortable: false,
                },
                {
                    name: 'extension',
                    required: true,
                    label: 'extension',
                    align: 'left',
                    field: 'extension',
                    sortable: false,
                },
                {
                    name: 'size',
                    required: true,
                    label: 'size',
                    align: 'left',
                    field: 'size',
                    sortable: false,
                },
                {
                    name: 'hits',
                    required: true,
                    label: 'downloads',
                    align: 'left',
                    field: 'hits',
                    sortable: false,
                }
            ],
            materials: [],
            loading: false,
            material: [],
            show_modal: false,
            id_course : '',
        }
    },

    components: {
        'material-modal': MaterialModal
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            has_event_listner: 'courses/has_event_listner',
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '90vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '90vw'
        },
    },

    methods: {
        requestMaterials({ pagination }) {
            this.loading = true
            let new_materials = []
            this.selected_server_pagination = pagination
            if (this.$q.platform.is.mobile) this.$q.loading.show()

            let url = `/etraining_presential/presential/${this.id_course}/get_presential_materials/`

            this.$axios.get(url, this.getHeader)
            .then(response => {
                response.data.forEach(material => {
                    new_materials.push({
                        id: material.id,
                        title: material.title,
                        extension: material.extension,
                        size: material.size,
                        hits: material.hits,
                        resource_url: material.resource_url,
                        resource_url_download: material.resource_url_download,
                        file_preview: material.file_preview,
                        change_state: false
                    })
                })

                this.materials = new_materials

                this.loading = false
                if (this.$q.platform.is.mobile) this.$q.loading.hide()
            })
            .catch(e => {
                this.loading = false
                if (this.$q.platform.is.mobile) this.$q.loading.hide()
                console.log(e)
            })
        },

        downloadFile(mat) {
            let file = mat.resource_url.substring(mat.resource_url.lastIndexOf('/')+1)
            let extension = file.substring(file.lastIndexOf('.'))
            let fileName = `${mat.title}${extension}`

            if (this.$q.platform.is.cordova) {
                window.open(mat.resource_url, '_system')
                this.hitDownload(mat)
            }
            else {
                window.open(mat.resource_url_download, '_blank')
                this.hitDownload(mat)
            }
        },

        hitDownload(mat) {
            this.$axios.get(`/etraining_presential/presential/${this.id_course}/presential_event_material/${mat.id}/request_presential_event_material_download/`, this.getHeader)
            .then(response => {

            })
            .catch(e => {
                console.log(e)
            })
        },

        showModal(material) {
            this.material = material
            this.material.change_state = !this.material.change_state
            this.show_modal = true
        },

        hideModal() {
            this.show_modal = false
            this.material = []
            this.requestMaterials({ pagination: this.server_pagination })
        }
    },

    created() {
        this.id_course = this.$route.params.id
        this.requestMaterials({ pagination: this.server_pagination })
    },

    mounted() {
        if (this.$q.platform.is.cordova && this.$q.platform.is.android) {
            let storage_location = 'file:///storage/emulated/0/'
            let folder = 'Downloads/' + process.env.PROJECT_FOLDER + '/'

            downloader.init({folder: folder, fileSystem: storage_location, noMedia: false})

            if (!this.has_event_listner) {
                document.addEventListener('DOWNLOADER_downloadSuccess', (event) =>{
                    this.$store.dispatch('courses/SET_HAS_EVENT_LISTNER', [true])

                    this.$q.loading.hide()

                    this.$q.notify({
                        message: this.$t('file_download_success'),
                        type: 'positive',
                        icon: 'fal fa-save'
                    })
                })

                document.addEventListener('DOWNLOADER_downloadError', (event) =>{
                    this.$q.loading.hide()
                })
            }
        }
    }
}
</script>

<style lang="stylus" scoped>
.line-card
    border-top: 3px solid transparent
    border-top-left-radius inherit
    border-top-right-radius inherit
</style>
